<template>
  <div>
    <transition name="fade">
      <Stats v-show="overlayVisible" />
    </transition>
    <div class="ui" style="display: flex;">
      <div class="field has-addons" style="margin-left: 1.5rem; margin-right: auto;"
        v-if="store.state.isFullscreen || isEmbedded()">
        <p class="control">
          <b-tooltip label="Show lot data" type="is-dark">
            <a class="button is-success is-large" v-on:click="toggleOverlay()">
              <span class="icon">
                <i class="zmdi zmdi-info"></i>
              </span>
            </a>
          </b-tooltip>
        </p>
      </div>
      <div class="field has-addons" style="margin-left: auto;">
        <p class="control">
          <b-tooltip :label="playing ? 'Start and stop the video' : 'Click to resume the video'
            " type="is-dark" :always="playing == false">
            <a class="button is-outlined is-white is-large" v-on:click="play()">
              <span class="icon">
                <i v-if="playing == true" class="zmdi zmdi-pause"></i>
                <i v-if="playing == false" class="zmdi zmdi-play"></i>
              </span>
            </a>
          </b-tooltip>
        </p>

        <p class="control">
          <b-tooltip label="Full screen" type="is-dark">
            <a class="button is-outlined is-white is-large" v-on:click="fs()">
              <span class="icon">
                <i class="zmdi zmdi-fullscreen"></i>
              </span>
            </a>
          </b-tooltip>
        </p>
        <p class="control">
          <b-dropdown aria-role="list" position="is-top-left">
            <template #trigger="{ }">
              <b-tooltip label="Settings" type="is-dark">
                <a class="button is-outlined is-white is-large" rel="nofollow">
                  <span class="icon">
                    <i class="zmdi zmdi-settings"></i>
                  </span> </a></b-tooltip>
            </template>

            <b-dropdown-item aria-role="listitem" @click="switchCodec">Change Quality (currently:
              {{ store.state.useVP8 ? 'LQ' : 'HQ' }})</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="store.state.showDebug = !store.state.showDebug">Toggle
              Debug</b-dropdown-item>
          </b-dropdown>
        </p>
        <p class="control" v-if="store.state.buyerCodes.length > 1">
          <b-dropdown aria-role="list" position="is-top-left" v-model="store.state.selectedBuyer">
            <template #trigger>
              <b-tooltip label="Buyer code to bid with" type="is-dark">
                <a class="button is-outlined is-white is-large">
                  <span class="icon">
                    <i class="zmdi zmdi-accounts-list"></i>
                  </span> </a></b-tooltip>
            </template>

            <b-dropdown-item aria-role="listitem" @click="switchBuyerCode(code)"
              v-for="(code, index) in store.state.buyerCodes" :key="index" :value="code">{{ code }}</b-dropdown-item>
          </b-dropdown>
        </p>
      </div>
      <div class="field is-grouped" style="margin-left: 0.75rem;">
        <p class="control bidcontrols">
          <b-tooltip label="Click once to hold the winning bid, click again to cancel" multilined type="is-dark"
            :always="holding">
            <button ref="holdbtn" class="button is-light is-large" v-bind:class="[
              { 'is-warning': holding },
              { 'is-light is-outlined': !holding }
            ]" @click="hold" :disabled="inhibit">
              <span class="is-size-7">{{ holding ? 'Cancel' : 'Hold' }}</span>
            </button>
          </b-tooltip>
        </p>
      </div>
      <div class="field has-addons">
        <p class="control bidcontrols" v-if="startOfLot">
          <b-tooltip label="Enter an opening bid amount" :always="true" type="is-dark">
            <span class="bidsuffix">
              <input type="number" class="button is-success is-outlined is-large startbid" placeholder="0" min="1"
                max="9999" pattern="[0-9]*" v-model="startOfLotAmount" @keyup.enter="bidStart" /></span>
          </b-tooltip>
        </p>

        <p class="control bidcontrols">
          <button ref="bidbtn" class="button is-success is-large" @click="startOfLotAmount != null ? bidStart() : bid()"
            :disabled="inhibit || holding">
            <span class="is-size-6">Place Bid</span>
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ui {
  position: absolute;
  top: auto;
  right: 0;
  bottom: 0.75rem;
  left: 0;
  z-index: 9;
  padding-right: 0.75rem;
  display: flex;
  flex-wrap: wrap;
}

.ui .startbid {
  width: 120px;
}

.ui .bidsuffix::after {
  content: '\00a2';
  position: absolute;
  top: 1rem;
  right: 0.5rem;
  z-index: 9999;
}

.ui input::-webkit-outer-spin-button,
.ui input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.ui-top {
  position: absolute;
  top: 0;
  right: 0;
  bottom: auto;
  left: 0;
  z-index: 8;
  padding: 0.75rem;
}

.ui-top p {
  font-size: 2rem;
  font-weight: bold;
  color: #ff3860;
  text-shadow: -1px -1px 1px #000, 1px -1px 1px #000, -1px 1px 1px #000,
    1px 1px 1px #000;
  line-height: normal;
}

.diag {
  position: absolute;
  line-height: normal;
  color: #ff3860;
  top: 0;
  left: 0;
  overflow-y: scroll;
  overflow-x: visible;
  padding: 2rem;
}

.diag pre {
  padding: unset;
  background-color: unset;
  color: unset;
}

.overlay {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  /* height: fit-content; */
  min-width: 25%;
  line-height: normal;
  overflow-y: scroll;
  overflow-x: visible;
  padding: 2rem;
  background-color: rgba(0, 0, 0, 0.25);

  color: white;
}

.overlay h1 {
  font-weight: bold;
  font-size: x-large;
  padding-bottom: 1rem;
}

.overlay table {
  width: 100%;
}

.overlay table tr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.overlay table tr th,
td {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.overlay table tr th {
  color: white;
  font-weight: normal;
}

.overlay table tr td {
  font-weight: bold;
  text-align: right;
}

.button.is-white.is-outlined {
  border: none;
}

.button.is-white.is-outlined:hover {
  background: none;
  color: white;
}

.bidcontrols button {
  margin-right: 1rem;
}

.prices {
  /* flex-basis: 100%; */
  text-align-last: end;
  margin-right: 1rem;
  margin-left: 2.5rem;
  display: flow-root;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.zmdi {
  text-shadow: 0 0 1.5px #444751;
}
</style>
<style>
.dropdown-menu {
  z-index: 100;
}
</style>

<script>
import { store } from '@/socket'
import { bus } from '../common/bus'

import log from 'loglevel'
import ScreenFull from 'screenfull'

import Vue from 'vue'
import Tooltip from 'buefy'
Vue.use(Tooltip)

export default {
  name: 'OSD',
  components: {
    Stats: () => import('@/components/Stats.vue')
  },
  data() {
    return {
      debug: false,
      store: store,
      playing: false,
      inhibit: false,
      holding: false,
      showOverlay: false,
      buyerSelector: false,
      startOfLot: false,
      startOfLotAmount: null,
      startLotPrices: ['100', '150', '200', '250', '300', '350']
    }
  },
  computed: {
    overlayVisible() {
      return this.showOverlay && (store.state.isFullscreen || this.isEmbedded())
    }
  },
  methods: {
    diagEmail() {
      return encodeURIComponent(
        'Please provide a description of the problem, if possible attach a screenshot:\n\n\nThe mess below contains technical information to help solve your issue, do not edit or reformat it:\n' +
        store.state.logBuffer
      )
    },
    switchCodec() {
      bus.$emit('switchCodec')
    },
    switchBuyerCode(code) {
      store.state.selectedBuyer = code
    },
    fs() {
      ScreenFull.toggle(document.getElementById('media'))
    },
    play() {
      bus.$emit('play')
    },
    hold() {
      if (store.state.selectedBuyer == '') {
        this.promptSignup()
        return
      }

      this.inhibit = true
      if (!this.holding) {
        bus.$emit('hold')
      } else {
        bus.$emit('cancel')
      }
      this.holding = !this.holding
    },
    bid() {
      if (store.state.selectedBuyer == '') {
        this.promptSignup()
        return
      }

      this.inhibit = true
      bus.$emit('bid')
    },
    bidStart() {
      if (store.state.selectedBuyer == '') {
        this.promptSignup()
        return
      }

      this.inhibit = true
      this.startOfLot = false
      bus.$emit('bidStart', this.startOfLotAmount)
      this.startOfLotAmount = null
    },
    ack() {
      this.startOfLot = false
      this.inhibit = false
    },
    result() {
      this.holding = false
    },
    toggleOverlay() {
      this.showOverlay = !this.showOverlay
    },
    isEmbedded() {
      let urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('embedded')) {
        return true
      }
      return this.$isMobile()
    },
    promptSignup() {
      this.$buefy.dialog.alert({
        title: "Looks like you don't have buyer permissions",
        message: `<div class="content"><h2>If you are already registered</h2>
					<p>Click logout, when you log back in your permissions will be refreshed.</p>
					<h2>If you would like to register</h2>
					<p>Contact BiddingMate on <a href="tel:8556 8497">(08) 8556 8497</a>, if you are an existing customer
						we only need to confirm your email address.</p></div>`,
        confirmText: 'Close',
        type: 'is-success',
        container: (function () {
          if (store.state.isFullscreen) {
            return '#app'
          } else {
            return null
          }
        })()
      })
    }
  },
  mounted() {
    log.info('OSD mounted')

    // Setup bus listeners
    let compCtx = this
    bus.$on('playing', function (val) {
      compCtx.playing = val
    })
    bus.$on('ack', this.ack)
    bus.$on('lotAdvance', function () {
      compCtx.holding = false
      compCtx.startOfLot = true
    })
    bus.$on('lotUpdate', function () {
      // compCtx.startOfLot = true
    })
    bus.$on('outbid', function () {
      compCtx.holding = false
      compCtx.startOfLot = false
    })

    // Fullscreen tracking
    ScreenFull.on('change', function () {
      store.state.isFullscreen = ScreenFull.isFullscreen
    })

    // this.showOverlay = this.isEmbedded()
    this.buyerSelector = store.state.selectedBuyer
  },
  destroyed() {
    bus.$off('playing')
    bus.$off('ack')
    bus.$off('lotAdvance')

    log.info('OSD destroyed')
  }
}
</script>
